import React from "react";

function Skills() {
  const skills = [
    { name: "React", level: 85 },
    { name: "JavaScript (ES6+)", level: 80 },
    { name: "Bootstrap", level: 75 },
    { name: "HTML5 & CSS3", level: 90 },
    { name: "Node.js", level: 70 },
    { name: "PHP", level: 65 },
    { name: "MySQL", level: 80 },
    { name: "Git & GitHub", level: 85 },
  ];

  return (
    <section id="skills" className="py-4 min-vh-100 text-light">
      <div className="container">
        <h2 className="text-center fw-bold mb-5">
          💡 My <span className="text-info">Skills</span>
        </h2>
        <div className="row g-4">
          <div className="col-12 mb-4 text-center">
            {skills.map((s, i) => (
              <span key={i} className="skill-badge">{s.name} · {s.level}%</span>
            ))}
          </div>

          {skills.map((skill, index) => (
            <div className="col-md-6" key={index}>
              <div className="card-modern shadow-lg mb-3 p-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="fw-bold text-info mb-0">{skill.name}</h6>
                    <small style={{ color: "#8b949e" }}>{skill.level}%</small>
                  </div>
                  <div className="progress" style={{ height: "10px" }}>
                    <div
                      className="progress-bar bg-info"
                      role="progressbar"
                      style={{ width: `${skill.level}%` }}
                      aria-valuenow={skill.level}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
